import Country from '~/Api/Country/Country';

export default class ReferenceBasketVersion {
	id: string;

	description?: string;

	sinceDate: Date;

	referencedCountry?: Country;

	referenceCountries?: Country[];

	otherEuEeaCountries?: Country[];

	otherEuropeCountries?: Country[];

	constructor(
		id: string,
		description: string,
		sinceDate: Date,
		referencedCountry: Country,
		referenceCountries: Country[],
		otherEuEeaCountries: Country[],
		otherEuropeCountries: Country[]
	) {
		this.id = id;
		this.description = description;
		this.sinceDate = sinceDate;
		this.referencedCountry = referencedCountry;
		this.referenceCountries = referenceCountries;
		this.otherEuEeaCountries = otherEuEeaCountries;
		this.otherEuropeCountries = otherEuropeCountries;
	}
}
